import { ref, computed } from 'vue';
import {officeRoute} from "@/helpers";


export const documentsCountByCategory = ref({});

let lastRequestedCategories = {};
export const getCategoryUnreadCount = (route, categories_ids) => {
  lastRequestedCategories = categories_ids;
  const fetch_needed = categories_ids.filter(id => !(id in documentsCountByCategory.value))

  for (let id of fetch_needed){
    fetch(officeRoute(route, {category:id}), { headers: {Accept: 'application/json'}})
        .then(res => res.json())
        .then((res) => documentsCountByCategory.value[id] = res)
  }
}

export const invalidateCategoryUnreadCount = (route) => {
  documentsCountByCategory.value= {};
  getCategoryUnreadCount(route, lastRequestedCategories)
}


export const unreadDocuments = ref(null);

let lastFetchRoute = null;

export const fetchUnreadDocuments = (url) => {
  if (lastFetchRoute !== url){
    lastFetchRoute = url;
    unreadDocuments.value = null;
    fetch(url, { headers: {Accept: 'application/json'}})
        .then(res => res.json())
        .then((res) => unreadDocuments.value = res)
  }
}

